// Arabic reception-lookup strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enReceptionLookup } from './en-reception-lookup.ts';
import type { Message } from './types.ts';

export const arReceptionLookup: { readonly [K in keyof typeof enReceptionLookup]: Message } = {
  'rlk.v.plate': 'أدخل رقم اللوحة بالأحرف والأرقام فقط.',
  'rlk.v.number': 'هذا الرقم غير صالح لنوع الوثيقة المختار.',
  'rlk.field': 'البحث حسب',
  'rlk.field.any': 'الاسم أو المرجع أو البطاقة أو رابط التصريح',
  'rlk.field.plate': 'لوحة المركبة',
  'rlk.field.document': 'رقم وثيقة الهوية',
  'rlk.hint.plate': 'اكتب اللوحة كما هي مكتوبة، مثل D 12345. تُطابَق الأحرف المتشابهة أيضاً (O و0، I و1).',
  'rlk.hint.document': 'اكتب الرقم من هوية الزائر. يُتحقق منه دون حفظه، ولا تُعرض إلا آخر أربعة أحرف.',
  'rlk.documentType': 'نوع الوثيقة',
  'rlk.documentType.any': 'أي نوع مفعّل',
  'rlk.documentJurisdiction': 'بلد الإصدار (لجوازات السفر)',
  'rlk.match.plate': 'اللوحة {masked}',
  'rlk.match.plateNear': 'اللوحة {masked} — أحرف متشابهة، تحقّق من اللوحة',
  'rlk.match.document': 'رقم الهوية {masked}',
};
